module.exports = __webpack_public_path__ + "static/img/Booking.5aea9fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Booking.png
// module id = jXBf
// module chunks = 0